import { Grid, Group } from '@mantine/core';
import DateRangePicker from '../DateRangePicker/DateRangePicker';

/**
 * AbTestSelector component for selecting date range for A/B test visualization.
 *
 * Props:
 * - startDate: string - ISO date "YYYY-MM-DD"
 * - endDate: string - ISO date "YYYY-MM-DD"
 * - setStartDate: (date: string) => void
 * - setEndDate: (date: string) => void
 * - minDate: string (optional) - ISO date "YYYY-MM-DD"
 * - maxDate: string (optional) - ISO date "YYYY-MM-DD"
 */
const AbTestSelector = ({ startDate, endDate, setStartDate, setEndDate, minDate, maxDate }) => {
  return (
    <Grid>
      <Grid.Col span={12}>
        <Group>
          <div data-tour="metricsSelector">
            <DateRangePicker
              preSetRanges={true}
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              minDate={minDate}
              maxDate={maxDate}
            />
          </div>
        </Group>
      </Grid.Col>
    </Grid>
  );
};

export default AbTestSelector;
